<template>
  <a-row style="margin:24px 0;">
    <a-col :span="6">
      <template v-if="reason">
        <p class="p__error">● 拒绝</p>
        <p>
          {{ reason }}
          <AudioReasonRich v-if="tag === 'audio'" :reason="result"> <a-icon type="info-circle"/></AudioReasonRich>
        </p>
      </template>
      <p v-else-if="suggestion" class="p__success">● 正常</p>
      <p v-else>● 未审核</p>
    </a-col>
    <a-col :span="18">
      <slot></slot>
    </a-col>
  </a-row>
</template>

<script>
import AudioReasonRich from '@/components/Audio/AudioReasonRich'
export default {
  props: ['reason', 'tag', 'result', 'suggestion'],
  components: { AudioReasonRich }
}
</script>

<style scoped>
.p__error {
  color: #f5222d;
}
.p__success {
  color: #52c41a;
}
</style>
